var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DC227CC6-AA36-43AA-87D8-91930F98CEF0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_02_05-Sign-Up-empty",
    transform: "translate(-645.000000, -377.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Default/Filled/primary-Copy",
    transform: "translate(523.000000, 368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-icon",
    transform: "translate(122.357143, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,9.71110303 C18,8.93 17.9387286,8.36 17.8061264,7.76889697 L9.18367347,7.76889697 L9.18367347,11.2944121 L14.2448589,11.2944121 C14.1428571,12.1705515 13.5918367,13.49 12.3673235,14.3766182 L12.3501591,14.4946496 L15.0764192,16.6793949 L15.2652983,16.698897 C16.9999609,15.0416545 18,12.6033091 18,9.71110303",
    id: "Path",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18367347,19 C11.6632301,19 13.7448393,18.1555151 15.2652983,16.698897 L12.3673235,14.3766182 C11.5918289,14.9360666 10.5509891,15.3266182 9.18367347,15.3266182 C6.75511767,15.3266182 4.69390882,13.6694485 3.95914459,11.378897 L3.85144483,11.388357 L1.01664074,13.6578054 L0.979568388,13.7644121 C2.48975684,16.8677212 5.59180547,19 9.18367347,19",
    id: "Path",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95914459,11.378897 C3.76527095,10.7877939 3.65306904,10.1544121 3.65306904,9.5 C3.65306904,8.84551513 3.76527095,8.21220605 3.94894442,7.62110303 L3.94380916,7.49521256 L1.07348033,5.18930678 L0.979568388,5.23551513 C0.357146765,6.52330908 0,7.96944849 0,9.5 C0,11.0305515 0.357146765,12.4766182 0.979568388,13.7644121 L3.95914459,11.378897",
    id: "Path",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18367347,3.67330908 C10.9081359,3.67330908 12.0713778,4.44386059 12.7346704,5.08779395 L15.3264993,2.47 C13.7347095,0.939448487 11.6632301,0 9.18367347,0 C5.59180547,0 2.48975684,2.13220605 0.979568388,5.23551513 L3.94894442,7.62110303 C4.69390882,5.33055151 6.75511767,3.67330908 9.18367347,3.67330908",
    id: "Path",
    fill: "#EB4335"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.8c61b813aa4acb6a95ceead754def018.svg";
export { ForwardRef as ReactComponent };